<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 519.3 76"
    style="enable-background: new 0 0 519.3 76"
    xml:space="preserve"
    :fill="fillColor"
  >
    <path
      d="M11.2,12.1h15.5c13.7,0,19.8,6.4,19.8,14.1c0,9-5.9,15.4-21.5,15.4H13.5v26.9h-2.3V12.1z M13.5,40.2h11.6
	c13.2,0,19.1-4.9,19.1-13.9c0-6.7-4.9-12.9-17.8-12.9H13.5V40.2z"
    />
    <path
      d="M62.2,39.9v28.6h-2.3V12.1h16.4c11.9,0,19.1,4.4,19.1,13.5c0,7.8-5.1,12.4-13,13.6c9.3,1.4,12.3,5.8,12.3,14.2v2.8
	c0,4.4,0.4,9.9,0.9,12.2h-2.4c-0.4-2.5-0.8-8.1-0.8-12.2v-2.7c0-10.9-5.6-13.6-17.3-13.6H62.2z M62.2,38.6h13.3
	c10.6,0,17.5-3.8,17.5-13c0-7.2-4.9-12.2-16.9-12.2H62.2V38.6z"
    />
    <path
      d="M150.1,39.9c0,18.8-5,29.3-21,29.3c-14.7,0-20.8-8.6-20.8-29.3c0-20.9,7.7-28.6,21.2-28.6C143.1,11.3,150.1,19.1,150.1,39.9
	z M110.6,39.8c0,20.3,6,28,18.5,28c14.8,0,18.7-11,18.7-27.9c0-18.3-5.1-27.1-18.5-27.1C117.4,12.8,110.6,19.9,110.6,39.8z"
    />
    <path
      d="M165.3,12.1h14.1c17.1,0,26,6.3,26,27.1c0,19.6-6.5,29.2-26.5,29.2h-13.6V12.1z M167.6,67.1h11c15.2,0,24.4-5.3,24.4-27.8
	c0-18.5-7-25.9-23.3-25.9h-12.2V67.1z"
    />
    <path
      d="M222.4,12.1v40.7c0,8,2.8,15,16.6,15s16.9-6.2,16.9-15V12.1h2.3v40.8c0,10-4.3,16.4-19.3,16.4c-14.1,0-18.8-6.1-18.8-16.2
	V12.1H222.4z"
    />
    <path
      d="M313,54.9c-0.8,4.1-2.8,14.3-18.9,14.3c-17.4,0-21.2-12.2-21.2-28.7c0-20.1,6.9-29.1,21.7-29.1s17.8,8.6,18.2,13.9h-2.2
	c-0.6-5.3-3.3-12.5-16-12.5c-12.5,0-19.4,7.3-19.4,27.6c0,16.5,4.1,27.4,19.1,27.4c14.1,0,15.9-9.2,16.5-12.9H313z"
    />
    <path d="M336.8,13.4h-19.2v-1.3h40.7v1.3h-19.2v55h-2.3V13.4z" />
    <path
      d="M364.1,55.5c0.3,7.5,6.5,12.4,16.8,12.4c10.7,0,16.4-5,16.4-12.9c0-7.6-4.6-11.6-16.1-15.6c-11.3-3.9-16.5-7.1-16.5-15.3
	c0-6.9,5-12.8,16.6-12.8c11.5,0,16.5,5.3,16.5,12.9h-2.2c-0.1-7.7-5.4-11.5-14.5-11.5c-10.6,0-14.2,5.5-14.2,11.4
	c0,7.2,3.7,10,15,13.9c12.9,4.5,17.7,8.7,17.7,17c0,7.3-4.6,14.2-18.8,14.2c-14.2,0-18.7-7.3-18.9-13.7H364.1z"
    />
    <path
      d="M410.7,69.2V11.3h17.1c20.3,0,29,8.4,29,28c0,21-8.8,29.9-29.5,29.9H410.7z M427,62.7c13.6,0,21.4-3.8,21.4-23.3
	c0-15.7-5.5-21.5-20.3-21.5H419v44.8H427z"
    />
    <path
      d="M413.7,14h14.1c17.1,0,26,5.9,26,25.3c0,18.3-6.5,27.2-26.5,27.2h-13.6V14z M416,65.3h11c15.2,0,24.4-5,24.4-25.9
	c0-17.3-7-24.1-23.3-24.1H416V65.3z"
    />
    <path
      d="M465.9,69.2V11.3h18.6c20.1,0,21.7,11.1,21.7,14.5c0,4-1.2,8.7-6.1,11.8c5.4,2.8,8.5,7.4,8.5,13.3c0,6.8-3.2,18.3-24.6,18.3
	H465.9z M484.2,62.6c10.9,0,16.2-3.8,16.2-11.6c0-2.4,0-9.7-16.1-9.7h-10v21.3H484.2z M484.3,34.6c12.6,0,13.6-4.5,13.6-8.7
	c0-6.6-7.5-7.9-13.8-7.9h-9.9v16.7H484.3z"
    />
    <path
      d="M468.9,14h15.6c13.8,0,18.7,5.7,18.7,11.8c0,8.5-6,11.1-11.4,12c5.8,0.9,13.8,4.1,13.8,13.1c0,8.4-5,15.6-21.6,15.6h-15.1
	V14z M484.3,37.3c12.5,0,16.6-4.3,16.6-11.4c0-5.9-4.6-10.6-16.8-10.6h-12.9v22H484.3z M471.2,65.2h12.9c12.8,0,19.2-5,19.2-14.2
	s-8.4-12.4-19.1-12.4h-13V65.2z"
    />
  </svg>
</template>

<script>
export default {
  name: "Logo",
  props: {
    fillColor: String,
  },
};
</script>